import _ from 'underscore';
import {RESET, SELECTION_CHANGED} from 'common/constants';
import SelectorBaseView from 'common/views/selector-base-view';
import SelectorOption from 'common/templates/selector-option.html';

export default SelectorBaseView.extend({
  getOptions() {
    const template = _.template(SelectorOption);
    const facilities = this.collection.getFacilities();
    return facilities
      .sort((aa, bb) => aa.displayName.localeCompare(bb.displayName))
      .map((datum) => {
        const facility = this.validateFacility(datum);
        if (facility && facility.points.length > 0) {
          return template({
            text: facility.displayName,
            value: facility.urlElement,
          });
        }
        return undefined;
      })
      .join('');
  },

  initialize() {
    this.collection.bind(RESET, this.onCollectionResetHandler, this);
    this.validateSelection = function (selection) {
      if (selection) {
        this.$el.val(selection);
      }
      this.select2();
      this.trigger(SELECTION_CHANGED, {
        selection: this.getSelectedItem(),
        target: this,
      });
    };
  },

  render() {
    const options = this.getOptions();
    this.$el.html(options);
    this.select2();
  },

  validateFacility(facility) {
    // Override
    // Gives sub-modules a chance to
    // Do something to an option before
    // It heads off for templating.
    // An example usage would be excluding
    // A facility whose meters don't
    // Meet some condition or other.
    return facility;
  },

  onCollectionResetHandler() {
    this.render();
  },
});
